var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"OperateNavTable"},[_vm._v(" 复试组合 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }